import { attributes, define } from "@type-r/models";
import { globalStore } from "api";
import { Page } from "lqx-react";
import * as React from "react";
import { CustomerProfileLandingSummary } from "../api/customer-profile";
import { SelectFilter, ToDo } from "../common";
import { TodoDetails as CustomerProfileTodoDetails, TodoTiles as CustomerProfileTodoTiles } from "./todo";

@define
export class CustomerProfileLandingState extends attributes({
    filter: 'todo',
    category: 'new-relationship',
    customerProfile: CustomerProfileLandingSummary
}) {
    async fetch() {
        await this.customerProfile.fetch();

        this.customerProfile.newRelationships.updateEach(element => {
            let customer = globalStore.getRelationshipById(element.relationshipId).Customer;
            if(!customer) return;
            element.hasCustomer = true;
            element.customerName = customer.companyName;
            element.customerExternalId = customer.externalRelationshipId;
        });

        return this;
    }

    get getCount() {
        return this.customerProfile.todoCount;
    }

    get isReady(){
        return this.customerProfile.isTodoReady;
    }
}

export const CustomerProfileLandingPage = ({ $state: $state }: { $state: CustomerProfileLandingState }) => {

    return (
        <Page
            menuWidth={450}
            maxWidth="xl"

            left={
                <>
                    <SelectFilter $filter={$state.$.filter} model={$state.customerProfile} type="cp" />
                    {
                        $state.filter === "todo" ?
                            <CustomerProfileTodoTiles $category={$state.$.category} model={$state.customerProfile} />
                            :
                            <ToDo />
                    }
                </>
            }
        >
            {
                $state.filter === 'todo' ?
                    <CustomerProfileTodoDetails category={$state.category} model={$state.customerProfile} />
                    :
                    <ToDo />
            }

        </Page>
    )
}